module.exports = __webpack_public_path__ + "img/dod19_image_03.b0a46fc6.jpg";